import React, { useState, useEffect } from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import DropdownCommon from "../DropdownCommon";
import EventHeader from "./CourseDetailsHeader";
import AddToCartVerticalBlock from "../AddToCartVerticalBlock";
import EventsDetails from "./EventsDetails";
import AvailableDates from "./AvailableDates";
import { timeZoneList } from "../../../constants/timeZoneList";
import { useSelector } from "react-redux";
import moment from 'moment';

function EventInner({ coursedetails }) {
  console.log("this is course details",coursedetails)
  const timeZones = coursedetails?.timezones;
  const userTimeZone = coursedetails?.user_timezone;
  const itemType = 'booking_event';
  const [bceDescription, setBceDescription] = useState(null);
  const [bceRefundPolicy, setBceRefundPolicy] = useState(null);
  const [bceCancellationPolicy, setBceCancellationPolicy] = useState(null);
  const [courseSlug, setCourseSlug] = useState('');
  const [course, setCourse] = useState('');
  const [eventSessions, setEventSessions] = useState([]);
  const [selectedTimeZone, setSelectedTimeZone] = useState('');
  const [selectedTimeZoneTxt, setSelectedTimeZoneTxt] = useState('');
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const [totalLecturesCount, setTotalLecturesCount] = useState(0);
  const [totalCoursesCount, setTotalCoursesCount] = useState(0);
  const [eventStartDate, setEventStartDate] = useState('');
  const [eventTimeDiff, setEventTimeDiff] = useState('');
  const [eventTimeFull, setEventTimeFull] = useState('');
  const [scheduleType, setScheduleType] = useState('');
  const [customSections, setCustomSections] = useState({});

  const GetMonthName = (monthNumber, full = false) => {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (full) {
      return monthsFull[monthNumber - 1];
    } else {
      return months[monthNumber - 1];
    }
  }

  const changeTimeZone = (e) => {
    let timeZone = e?.name_without_offset;
    let timeZoneTxt = e?.name;
    setSelectedTimeZone(timeZoneList[timeZone]);
    // setSelectedTimeZoneTxt(timeZoneTxt);

    localStorage.setItem("selected_timezone", timeZone);
    localStorage.setItem("selected_timezone_txt", timeZoneTxt);

    if (timeZone == "") {
      localStorage.removeItem("selected_timezone");
      localStorage.removeItem("selected_timezone_txt");
    }
    localStorage.selected_timezone = timeZone;
    localStorage.selected_timezone_txt = timeZoneTxt;

  }

  useEffect(() => {
    if (coursedetails && typeof coursedetails !== 'undefined') {
      console.log('coursedetails', coursedetails);
      setCourse(coursedetails.course);
      setCourseSlug(coursedetails.course_slug);
      // setEventSessions(coursedetails.course.event_activities);
      setEventSessions(coursedetails.event_all_activity);
      setBceDescription(coursedetails.course.bce_description);
      setBceRefundPolicy(coursedetails.course.bce_refund_policy);
      setBceCancellationPolicy(coursedetails.course.bce_cancellation_policy);
      setScheduleType(coursedetails.course.bce_schedule_type);
      setCustomSections(typeof coursedetails.course.bce_custom_sections != 'undefined' ? JSON.parse(coursedetails.course.bce_custom_sections) : {});
      // console.log('custom section', customSections);

      let selected_timezone = selectedTimeZone?.name_without_offset;

      let default_start_datetime = moment(coursedetails.course.bce_start_date + ' ' + coursedetails.course.bce_start_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);

      let default_end_datetime = moment(coursedetails.course.bce_end_date + ' ' + coursedetails.course.bce_end_time, "YYYY-MM-DD h:mm:ss A").tz('UTC', true);

      let start_date_tz = default_start_datetime.format("DD-MM-YYYY");
      let start_time_tz = default_start_datetime.format("h:mm A");
      let end_date_tz = default_end_datetime.format("DD-MM-YYYY");
      let end_time_tz = default_end_datetime.format("h:mm A");

      if (typeof selected_timezone !== 'undefined' && selected_timezone != '') {
        var tz_start_datetime = moment(default_start_datetime).tz(selected_timezone);
        var tz_end_datetime = moment(default_end_datetime).tz(selected_timezone);
        start_date_tz = tz_start_datetime.format("DD-MM-YYYY");
        start_time_tz = tz_start_datetime.format("h:mm A");
        end_date_tz = tz_end_datetime.format("DD-MM-YYYY");
        end_time_tz = tz_end_datetime.format("h:mm A");

      }

      var date_diff = (Date.parse(end_date_tz) - Date.parse(start_date_tz)) / 86400000;

      var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      var startDate = start_date_tz.split('-');
      var startMonth = GetMonthName(Number(startDate[1]).toString());
      let startMonthFull = GetMonthName(Number(startDate[1]).toString(), true);
      var startDay = startDate[0];
      var newDate = new Date(startDate[1] + '/' + startDate[0] + '/' + startDate[2]);
      var startDayName = weekday[newDate.getDay()];
      var startMonthNumber = (newDate.getMonth()) + 1;
      let startYear = startDate[2];

      let startDateOnly = `${startDayName}, ${startDay} ${startMonthFull} ${startYear}`;
      console.log(startDateOnly);
      setEventStartDate(startDateOnly);

      var endDate = end_date_tz.split('-');
      var endMonth = GetMonthName(Number(endDate[1]).toString());
      var endDay = endDate[0];
      var endYear = endDate[2];

      var now = moment(default_end_datetime);
      var then = moment(default_start_datetime);

      var duration = moment.duration(now.diff(then));
      var dayDiff = duration.days();
      var hourDiff = duration.hours();
      var minutesDiff = duration.minutes();
      var diff = '';
      if (dayDiff > 0) {
        diff += dayDiff + ' D ';
      }
      if (hourDiff > 0) {
        diff += hourDiff + ' Hr ';
      }
      if (minutesDiff > 0) {
        diff += minutesDiff + ' Min';
      }

      setEventTimeDiff(diff);

      if (coursedetails.course.bce_schedule_type == 'basic' && selected_timezone != '') {
        // if(tz_start_datetime.format("L") === tz_end_datetime.format("L")) {
        //   setEventTimeFull(start_time_tz+' - '+end_time_tz+' ('+diff+')');
        // } else {
        setEventTimeFull(startDay + ' ' + startMonth + ' ' + startYear + ' ' + start_time_tz + ' - ' + endDay + ' ' + endMonth + ' ' + endYear + ' ' + end_time_tz);
        // }
      }
    }
  }, [coursedetails, selectedTimeZone]);

  useEffect(() => {
    const selectedTimeZoneTemp = timeZoneList[localStorage.getItem("selected_timezone") ? localStorage.getItem("selected_timezone") : miscellaneous.configured_time_zone];
    setSelectedTimeZone(selectedTimeZoneTemp);
  }, [timeZoneList]);

  const defaultObj = { "value": selectedTimeZone.name_without_offset, "name": selectedTimeZone.name };
  return (
    <>
      <div className='res-add-cart-block'>
        <AddToCartVerticalBlock totalLecturesCount={totalLecturesCount} totalCoursesCount={totalCoursesCount} coursedetails={coursedetails} itemType={itemType} />
      </div>
      <EventHeader eventTimeFull={eventTimeFull} course={course} className="mb-4 biki" />
      <Container>
        <Row>
          <div className='res-add-cart-detail-block'>
            <Container>
              <AddToCartVerticalBlock totalLecturesCount={totalLecturesCount} totalCoursesCount={totalCoursesCount} coursedetails={coursedetails} itemType={itemType} />
            </Container>
          </div>
          <Col lg={8}>
            <Container className="mb-3">
              <Row className="justify-content-lg-end">
                <Col lg={4}>
                  <DropdownCommon defaultValue={defaultObj} items={Object.values(timeZoneList)} label={'Select Timezone'} onChange={changeTimeZone} className="mb-0" />
                </Col>
              </Row>
            </Container>
            <AvailableDates courseSlug={courseSlug} className="mb-4" />
            <EventsDetails customSections={customSections} selectedTimeZone={selectedTimeZone} setTotalLecturesCount={setTotalLecturesCount} setTotalCoursesCount={setTotalCoursesCount} eventSessions={eventSessions} bceDescription={bceDescription} bceRefundPolicy={bceRefundPolicy} bceCancellationPolicy={bceCancellationPolicy} />
          </Col>
          <Col lg={4}>
            <div className='mobile-add-cart-block'>
              <AddToCartVerticalBlock totalLecturesCount={totalLecturesCount} totalCoursesCount={totalCoursesCount} coursedetails={coursedetails} itemType={itemType} />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default EventInner;
